"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _pagenavigation = _interopRequireDefault(require("../pagenavigation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => {
  var _theme$palette$backgr;
  return {
    paper: {
      background: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 || (_theme$palette$backgr = _theme$palette$backgr.header) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.appBar,
      bottom: 0
    },
    drawerPaper: {
      boxShadow: "none",
      height: "auto",
      top: 0,
      width: "100%"
    },
    halfSize: {
      overflowY: "auto",
      width: "clamp(280px, 90vw, 400px)"
    },
    view: {
      display: "flex",
      flexDirection: "column"
    }
  };
});
const UIDrawer = props => {
  const {
    open,
    setMenuOpen,
    title,
    background = "#FFFFFF",
    align = "right",
    fullscreen = true
  } = props;
  const css = useStyles();
  const close = () => {
    setMenuOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    BackdropProps: {
      invisible: fullscreen
    },
    PaperProps: {
      className: css.paper,
      style: {
        background
      }
    },
    classes: {
      paper: (0, _clsx.default)({
        [css.drawerPaper]: true,
        [css.halfSize]: !fullscreen
      })
    },
    anchor: align,
    open: open,
    onClose: () => setMenuOpen(false)
  }, title ? /*#__PURE__*/_react.default.createElement(_pagenavigation.default, {
    fixed: true,
    saveTopAreaPadding: true,
    close: close,
    title: title
  }) : "", props.children);
};
var _default = exports.default = UIDrawer;